const compatModules = {};import * as Mod1 from "./discourse/components/waze-ai-header-icon";
compatModules["discourse/components/waze-ai-header-icon"] = Mod1;

export * as discourse$components$waze__ai__header__icon$$__module from "./discourse/components/waze-ai-header-icon";
export {
default as discourse$components$waze__ai__header__icon$$default
} from "./discourse/components/waze-ai-header-icon";
import * as Mod2 from "./discourse/components/waze-app-launcher";
compatModules["discourse/components/waze-app-launcher"] = Mod2;

export * as discourse$components$waze__app__launcher$$__module from "./discourse/components/waze-app-launcher";
export {
default as discourse$components$waze__app__launcher$$default
} from "./discourse/components/waze-app-launcher";
import * as Mod3 from "./discourse/components/waze-user-box";
compatModules["discourse/components/waze-user-box"] = Mod3;

export * as discourse$components$waze__user__box$$__module from "./discourse/components/waze-user-box";
export {
default as discourse$components$waze__user__box$$default
} from "./discourse/components/waze-user-box";
import * as Mod4 from "./discourse/connectors/user-dropdown-notifications__before/user-dropdown-bell-icon.gjs";
compatModules["discourse/connectors/user-dropdown-notifications__before/user-dropdown-bell-icon"] = Mod4;

export * as discourse$connectors$user__dropdown__notifications__before$user__dropdown__bell__icon$$__module from "./discourse/connectors/user-dropdown-notifications__before/user-dropdown-bell-icon.gjs";
export {
default as discourse$connectors$user__dropdown__notifications__before$user__dropdown__bell__icon$$default
} from "./discourse/connectors/user-dropdown-notifications__before/user-dropdown-bell-icon.gjs";
import * as Mod5 from "./discourse/initializers/waze-header-initializer";
compatModules["discourse/initializers/waze-header-initializer"] = Mod5;

export * as discourse$initializers$waze__header__initializer$$__module from "./discourse/initializers/waze-header-initializer";
export {
default as discourse$initializers$waze__header__initializer$$default
} from "./discourse/initializers/waze-header-initializer";
export default compatModules;
